if (!customElements.get('bb-recommendation-scroller')) {
  customElements.define('bb-recommendation-scroller', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('[data-bb-recommendation-track]');
      this.controls = this.querySelector('[data-bb-recommendation-controls]');
      this.previous = this.querySelector('[data-bb-recommendation-prev]');
      this.next = this.querySelector('[data-bb-recommendation-next]');
      if (!this.track || !this.controls || !this.previous || !this.next) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.desktop = matchMedia('(min-width: 750px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.updateControls(), { ...options, passive: true });
      this.desktop.addEventListener('change', () => this.updateControls(), options);
      this.resizeObserver = new ResizeObserver(() => this.updateControls());
      this.resizeObserver.observe(this.track);
      this.updateControls();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }

    updateControls() {
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.controls.hidden = !this.desktop.matches || maxScroll <= 1;
      this.previous.disabled = this.track.scrollLeft <= 1;
      this.next.disabled = this.track.scrollLeft >= maxScroll - 1;
    }

    move(direction) {
      if (!this.desktop.matches) return;
      const first = this.track.firstElementChild;
      if (!first) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({
        left: direction * (first.getBoundingClientRect().width + gap),
        behavior: this.reduced.matches ? 'auto' : 'smooth',
      });
    }
  });
}
